import search from './search.vue'

export default search



// WEBPACK FOOTER //
// ./src/components/xesMallSearch/index.js